
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import React, { Component } from "react";
// reactstrap components
import {
  Container,
  Row,
  Col,
  Button
} from "reactstrap";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import connect from 'redux-connect-decorator';
import { getTopStudents } from '../../actions/topStudentActions';

@connect(
  state => ({
    topStudents: state.topStudent.topStudents,
    loading: state.topStudent.loading
  }),
  {
    getTopStudents
  }
)
class TopStudent extends Component<any, any> {

  componentDidMount() {
    this.props.getTopStudents();
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      speed: 2000,
      autoplaySpeed: 3000,
      cssEase: "linear"
    };

    const { topStudents } = this.props;

    return (
      <>
        <section className="py-4">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <div className="order-md-2" style={{ width: '300px', height : '300px', margin: 'auto'}}>
                    { topStudents && <Slider {...settings}>
                      {topStudents.map((item, i) => (
                        <div key={`top-student-${i}`} >
                          <img style={{ height : '300px'}} src={item.img_url } />
                        </div>
                      ))
                      }
                    </Slider>
                    }
                  </div>
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5 bg-diploma" style={{ height: '310px'}}>
                    <h1>CÁC HỌC VIÊN THÀNH CÔNG</h1>
                    <p>
                      Các học viên đã vượt qua kỳ thi với số điểm hơn 90%
                    </p>
                    <Link
                      className="font-weight-bold text-warning mt-5"
                      to="/admin/profile"
                    >
                      Xem thêm ...
                    </Link>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        {/* <section className="py-6">
            <Container>
            <Row className="row-grid align-items-center">
                <Col md="12">
                  <div className="pr-md-5">
                    <h1>CÁC HỌC VIÊN THÀNH CÔNG VỚI PASS RATE 90%</h1>
                    <Link
                      className="font-weight-bold text-warning mt-5"
                      to="/admin/profile"
                    >
                      Explore pages
                    </Link>
                  </div>
                </Col>
              </Row>
              <Row className="row-grid align-items-center">
                <Col md="4">
                  <TopStudentCard name="Thai Bach" link="https://cclmagic-data.s3-ap-southeast-2.amazonaws.com/score1.png" />
                </Col>
                <Col md="4">
                  <TopStudentCard name="Thu Nga" link="https://cclmagic-data.s3-ap-southeast-2.amazonaws.com/score2.png" />
                </Col>
                <Col md="4">
                  <TopStudentCard name="Thien Hao" link="https://cclmagic-data.s3-ap-southeast-2.amazonaws.com/score3.png" />
                </Col>
              </Row>
            </Container>
          </section> */}
      </>
    )
  }
}

export default TopStudent;
